<template>
  <card>
    <h4 slot="header" class="card-title">Yeni Kullanıcı</h4>
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      labelAlign="left"
      >
      <a-form-model-item ref="first_name" label="İsim" prop="first_name">
        <a-input
          placeholder="İsim"
          v-model="form.first_name"
          @blur="
            () => {
              $refs.first_name.onFieldBlur();
            }
          "
        />
      </a-form-model-item>
      <a-form-model-item ref="last_name" label="Soyisim" prop="last_name">
        <a-input
          placeholder="Soyisim"
          v-model="form.last_name"
          @blur="
            () => {
              $refs.last_name.onFieldBlur();
            }
          "
        />
      </a-form-model-item>
      <a-form-model-item ref="email" label="Email" prop="email">
        <a-input
          v-model="form.email"
          placeholder="Email"
          @blur="
            () => {
              $refs.email.onFieldBlur();
            }
          "
        />
      </a-form-model-item>
      <a-form-model-item has-feedback label="Şifre" prop="password">
        <a-input placeholder="Şifre" v-model="form.password" type="password" autocomplete="off" />
      </a-form-model-item>
      <a-form-model-item has-feedback label="Onayla" prop="checkPass">
        <a-input placeholder="Şifre Tekrarı" v-model="form.checkPass" type="password" autocomplete="off" />
      </a-form-model-item>
      <a-form-model-item has-feedback label="Kumbara Atama" prop="moneybox_assignment">
        <a-select
          show-search
          label-in-value
          option-filter-prop="children"
          mode="multiple"
          style="width: 100%"
          placeholder="Kumbara seçiniz"
          :filter-option="filterOption"
          @focus="handleFocus"
          @blur="handleBlur"
          @change="handleChange"
        >
          <a-select-option v-for="d in moneyboxList" :value="d.value" v-key="d.value">
            {{d.text}}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 14, offset: 5 }">
        <a-button :loading="loading" type="primary" @click="onSubmit">
          Oluştur
        </a-button>
        <a-button style="margin-left: 10px;" @click="resetForm">
          Sıfırla
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </card>
</template>
<script>
  import { mapState } from "vuex"
  import Card from 'src/components/Cards/Card.vue'

  export default {
    mounted(){
      const self = this
      self.$store.dispatch("Moneybox/requestMoneyboxList")
    },
    computed: {
      ...mapState({
        moneyboxes: state => state.Moneybox.moneyboxes
      }),
      moneyboxList(){
        if(!this.moneyboxes.moneyboxes)return []
        return this.moneyboxes.moneyboxes.map(item => {
          return {
            text: item.name,
            value: item.id
          }
        })
      }
    },
    components: {
      Card
    },
    data () {
      let validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Şifre alanı boş bırakılamaz.'));
        } else {
          if(value.length < 3){
            callback(new Error('Şifre alanı min 3, max 20 karakter uzunluğunda olabilir'));
          }
          if (this.form.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      let validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Şifre alanı boş bırakılamaz.'));
        } else if (value !== this.form.password) {
          callback(new Error("Şifre alanlarındaki veriler eşlemelidir."));
        } else {
          callback();
        }
      };
      return {
        selected_moneyboxes:[],
        loading: false,
        labelCol: { span: 4 },
        wrapperCol: { span: 10 },
        other: '',
        form: {
          first_name: '',
          last_name: '',
          email: '',
          password: '',
          checkPass: '',
        },
        rules: {
          password: [
            { required: true, validator: validatePass, trigger: 'change' },
          ],
          checkPass: [{ required: true, validator: validatePass2, trigger: 'change' }],
          first_name: [
            { required: true, message: 'İsim alanını boş bırakmayınız', trigger: 'blur' },
            { min: 3, max: 20, message: 'İsim alanı min 3, max 20 karakter uzunluğunda olabilir', trigger: 'blur' },
          ],
          last_name: [
            { required: true, message: 'Soyisim alanını boş bırakmayınız', trigger: 'blur' },
            { min: 3, max: 20, message: 'Soyisim alanı min 3, max 20 karakter uzunluğunda olabilir', trigger: 'blur' },
          ],
          email: [
            { required: true, message: 'Email alanını boş bırakmayınız', trigger: 'blur' },
            { min: 3, max: 20, message: 'Email alanı min 3, max 20 karakter uzunluğunda olabilir', trigger: 'blur' },
          ],
        },
      }
    },
    methods: {
      handleChange(value) {
        this.selected_moneyboxes = value
      },
      handleBlur() {
        console.log('blur');
      },
      handleFocus() {
        console.log('focus');
      },
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      onSubmit() {
        const self = this
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            self.loading = true
            self.$store.dispatch("Users/requestUserCreate", self.form).then((user)=> {
              self.$notification['success']({
                message: 'Kullanıcı Ekleme',
                description:
                  'Kullanıcı başarılı bir şekilde oluşturuldu :)',
              });
              if(self.selected_moneyboxes.length){
                self.$store.dispatch("Users/requestUserMoneyboxAssignmentCreate", {
                  user_id: user.id,
                  selected_moneyboxes: self.selected_moneyboxes
                })
              }
              self.$router.push('/admin/users/')
            }).catch(()=> {
              self.$notification['error']({
                message: 'Kullanıcı Ekleme',
                description:
                  'Kullanıcı eklenirken bir hata oluştu :/',
              });
            }).finally(()=> {
              self.loading = false
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm() {
        this.$refs.ruleForm.resetFields();
      }
    }
  }

</script>
<style>

</style>
